import { InboxRulesOptionState } from '../../store/schema/InboxRulesOptionState';
import store from '../../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getContextMenuFolders from './getContextMenuFolders';
import folderStore, { getPrimaryMailFolders } from 'owa-folders';

export interface InitializeInboxRulesFoldersState {
    optionState: InboxRulesOptionState;
}

/**
 * Makes the find folder service call and adds the folders to the create/edit inbox rule store
 */
export default action('initializeInboxRulesFolders')(
    select<InitializeInboxRulesFoldersState>({
        optionState: () => store,
    })(async function initializeInboxRulesFolders(
        state?: InitializeInboxRulesFoldersState
    ): Promise<void> {
        getPrimaryMailFolders();

        const junkFolderId = folderNameToId('junkemail');
        state.optionState.contextMenuFolders = getContextMenuFolders();
        state.optionState.junkFolderDisplayName = folderStore.folderTable.get(
            junkFolderId
        ).DisplayName;
    })
);
